var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4974 21.8753V26.2503M32.0807 17.7978V20.016C32.0807 25.7034 32.0807 28.5487 30.3716 30.3162C28.6624 32.0837 25.9134 32.0837 20.4141 32.0837H14.5807C9.08135 32.0837 6.33094 32.0837 4.62323 30.3162C2.91552 28.5487 2.91406 25.7049 2.91406 20.016V17.7978C2.91406 14.4597 2.91406 12.7914 3.6724 11.4089C4.42781 10.0249 5.81177 9.16741 8.57823 7.44949L11.4949 5.6397C14.4189 3.82408 15.8816 2.91699 17.4974 2.91699C19.1132 2.91699 20.5745 3.82408 23.4999 5.6397L26.4166 7.44949C29.183 9.16741 30.567 10.0249 31.3239 11.4089",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconDark);
export default __webpack_public_path__ + "static/media/home-icon-dark.e8451b54ad050ebfe760c51026b81e46.svg";
export { ForwardRef as ReactComponent };